import {
  CadastroNCByFile, GETFileNotaComercialByFileParams, GETNotasComerciaisByFileParams, getFileByNotaComercialResponse, getNotaComercialByFileResponse, postFundosInvestidoresLoteByFileResponse, postNotaComercialByFileResponse,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  GETAllNotasComerciaisByFile,
  GETFileNotaComercialByFile,
  GETFileDownloadArquivo,
  POSTNotaComercialByFile,
  POSTNotaComercialCadastroEmLoteByFile,
  POSTFundosInvestidoresLoteByFile,
  POSTDownloadMultipleFiles,
} from 'requests/notaComercial';
import { typedAction } from 'store/modules/base';

import { ArquivosMultiplos, BatchFileDownloadResponse } from 'common/types/arquivosMultiplos';

export interface NotaComercialApiByFileState {
  postNotaComercialByFile(
    dispatch: Dispatch,
    NotaComercial: CadastroNCByFile,
    stackRequest?: boolean
  ): Promise<postNotaComercialByFileResponse>;
  postNotaComercialCadastroLoteByFile(
    dispatch: Dispatch,
    file?: File,
    stackRequest?: boolean
  ): Promise<postNotaComercialByFileResponse>;
  postFundosInvestidoresLoteByFile(
    dispatch: Dispatch,
    file?: File,
    stackRequest?: boolean
  ): Promise<postFundosInvestidoresLoteByFileResponse>;
  getAllNotasComerciaisByFile(
    dispatch: Dispatch,
    params: GETNotasComerciaisByFileParams,
    stackRequest?: boolean
  ): Promise<Array<getNotaComercialByFileResponse>>;
  getFileNotaComercialByFile(
    dispatch: Dispatch,
    params: GETFileNotaComercialByFileParams,
    stackRequest?: boolean
  ): Promise<getFileByNotaComercialResponse>;
  getFileDownloadArquivo(
    dispatch: Dispatch,
    params: GETFileNotaComercialByFileParams,
    stackRequest?: boolean
  ): Promise<Blob>;
  downloadMultipleFiles(
    dispatch: Dispatch,
    params: ArquivosMultiplos,
    stackRequest?: boolean
  ): Promise<BatchFileDownloadResponse[]>;
}

export const NotaComercialApiByFileInicialState: NotaComercialApiByFileState = {
  postNotaComercialByFile: POSTNotaComercialByFile,
  postNotaComercialCadastroLoteByFile: POSTNotaComercialCadastroEmLoteByFile,
  postFundosInvestidoresLoteByFile: POSTFundosInvestidoresLoteByFile,
  getAllNotasComerciaisByFile: async (dispatch: Dispatch, params: GETNotasComerciaisByFileParams, stackRequest?: boolean) => {
    return await GETAllNotasComerciaisByFile(dispatch, params, stackRequest);
  },
  getFileNotaComercialByFile: async (dispatch: Dispatch, params: GETFileNotaComercialByFileParams, stackRequest?: boolean) => {
    return await GETFileNotaComercialByFile(dispatch, params, stackRequest);
  },
  getFileDownloadArquivo: async (dispatch: Dispatch, params: GETFileNotaComercialByFileParams, stackRequest?: boolean) => {
    return await GETFileDownloadArquivo(dispatch, params, stackRequest);
  },
  downloadMultipleFiles: async (dispatch: Dispatch, params: ArquivosMultiplos, stackRequest?: boolean) => {
    return await POSTDownloadMultipleFiles(dispatch, params, stackRequest);
  },
};

enum NotaComercialApiActionType {
  Update = 'notaComercialByFileApi/UPDATE',
  Reset = 'notaComercialByFileApi/RESET',
}

export const updateNotaComercialApi = (state: NotaComercialApiByFileState) => {
  return typedAction(NotaComercialApiActionType.Update, state);
};

export const resetNotaComercialApi = () => {
  return typedAction(NotaComercialApiActionType.Reset);
};

type NotaComercialApiAction = ReturnType<typeof updateNotaComercialApi | typeof resetNotaComercialApi>;

export function notaComercialByFileApiReducer(
  state: NotaComercialApiByFileState = NotaComercialApiByFileInicialState,
  action: NotaComercialApiAction
): NotaComercialApiByFileState {
  switch (action.type) {
    case NotaComercialApiActionType.Update:
      return { ...action.payload };
    case NotaComercialApiActionType.Reset:
      return { ...NotaComercialApiByFileInicialState };
    default:
      return state;
  }
}
